import { useContext } from '@nuxtjs/composition-api'
import { BRAND_MEDIA_NEUTRAL } from '../../../../config/bitrix-endpoints'
import { BITRIX_API } from '../../instance'

export async function neutralArticle(
  ctx: ReturnType<useContext> | undefined = undefined,
  id: number | undefined = undefined
) {
  return await BITRIX_API(ctx).post(`${BRAND_MEDIA_NEUTRAL}/${id}`)
}
